import React from 'react';
import styled from '@emotion/styled';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import { Typography, TypographyVariant } from '@taleemabad/dsm/components';
import { AlignUrduWrapper } from '../align-urdu/align-urdu';
import { isUrduText, containsUrduCharacters } from '@taleemabad/dsm/utils';

const StyledReactMarkdown = styled(ReactMarkdown)`
  p {
    margin: 0;
  }
  strong {
    font-weight: 600 !important;
  }
`;

interface MarkdownWrapperProps {
  text: string;
  variant?: string;
  className?: string;
  useContainsUrdu?: boolean;
}

export const MarkdownWrapper: React.FC<MarkdownWrapperProps> = ({
  text,
  variant = 'textBodyMediumSurface',
  className = '',
  useContainsUrdu = false,
}) => {
  const checkUrdu = useContainsUrdu ? containsUrduCharacters : isUrduText;
  const isUrdu = checkUrdu(text);

  const markdown = (
    <StyledReactMarkdown
      rehypePlugins={[rehypeRaw]}
      className={className}
      components={{
        p: ({ children }) => (
          <Typography variant={variant as TypographyVariant}>
            {children}
          </Typography>
        ),
      }}
    >
      {text}
    </StyledReactMarkdown>
  );

  return isUrdu ? (
    <AlignUrduWrapper isUrdu={true}>{markdown}</AlignUrduWrapper>
  ) : (
    markdown
  );
};
